"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPEventManager = void 0;
const event_manager_1 = require("./event_manager");
class OPEventManager extends event_manager_1.EventManager {
    constructor(options) {
        super();
        this.options = options;
    }
    getAllEvents(realAtomEvents, virtualAtomEvents) {
        const { op2Event, options: { enableCombEvent } } = this.options;
        let combEvents = [];
        const atomEvents = [...realAtomEvents, ...virtualAtomEvents];
        if (enableCombEvent) {
            combEvents = op2Event.makeCombEvents(atomEvents);
        }
        const events = [...atomEvents, ...combEvents];
        // console.log('events', events);
        return events;
    }
    asyncHandleChangesets(changesets) {
        return __awaiter(this, void 0, void 0, function* () {
            const { op2Event, options: { enableVirtualEvent, enableEventComplete, enableCombEvent }, getState } = this.options;
            const realAtomEvents = op2Event.parseOps2Events(changesets);
            let virtualAtomEvents = [];
            let state;
            if (enableVirtualEvent) {
                const resourceMap = op2Event.getOpsResources(realAtomEvents);
                state = yield getState(resourceMap);
                virtualAtomEvents = op2Event.makeVirtualEvents(realAtomEvents, state);
            }
            if (enableEventComplete) {
                if (!state) {
                    const resourceMap = op2Event.getOpsResources(realAtomEvents);
                    state = yield getState(resourceMap);
                }
                let combEvents = [];
                const atomEvents = [...realAtomEvents, ...virtualAtomEvents];
                if (enableCombEvent) {
                    combEvents = op2Event.makeCombEvents(atomEvents);
                }
                const events = [...atomEvents, ...combEvents];
                return op2Event.fillEvents(events, state);
            }
            return this.getAllEvents(realAtomEvents, virtualAtomEvents);
        });
    }
    handleChangesets(changesets) {
        const { op2Event, options: { enableVirtualEvent }, getState } = this.options;
        const realAtomEvents = op2Event.parseOps2Events(changesets);
        let virtualAtomEvents = [];
        if (enableVirtualEvent) {
            const resourceMap = op2Event.getOpsResources(realAtomEvents);
            const state = getState(resourceMap);
            virtualAtomEvents = op2Event.makeVirtualEvents(realAtomEvents, state);
        }
        return this.getAllEvents(realAtomEvents, virtualAtomEvents);
    }
}
exports.OPEventManager = OPEventManager;
//# sourceMappingURL=op_event_manager.js.map